// "2026-07-06T10:30:00+01:00" -> "10:30" (the server-zone wall-clock time,
// which is what the dispatch period boundaries are defined against).
const clockTime = (isoDateTime: string): string => (isoDateTime.split("T")[1] ?? "").slice(0, 5);

export default clockTime;
